import {
  ShareableType,
  ShareTargetType,
} from '@bindoc-projects/resource-domain-lib';

export class BdPermissionsResourcesAdminStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return this._baseUrl;
  }

  public all(): string {
    return `${this.base()}/shareables/all`;
  }

  public byTarget(
    shareTargetType: ShareTargetType,
    shareTargetId: string,
  ): string {
    return `${this.base()}/shareables/admin/${shareTargetType}/${shareTargetId}/`;
  }

  /** The access graph of a shareable (BDA-5988), from the admin view. */
  public accessGraph(
    shareableType: ShareableType,
    shareableId: string,
  ): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/access-graph/`;
  }

  public available(): string {
    return `${this.base()}/shareables/types/available/`;
  }
}
